import { createSelector } from '@ngrx/store';
import * as R from 'ramda';
import { NgRxTcFilterState, TcFilterState } from '../state/tc-filter-state';

/**
 * Get tc filter from store by store key
 */
export const getTcFiltersByStoreKey = (
  state: NgRxTcFilterState,
  props: { storeKey: string }
) => R.prop(props.storeKey)(state);

/**
 * Get tc filters
 */
export const getTcFilters = createSelector(
  getTcFiltersByStoreKey,
  (state: TcFilterState) => {
    return R.propOr([], 'filter')(state);
  }
);

/**
 *  Get Tc config
 */
export const getTcFilterConfig = createSelector(
  getTcFiltersByStoreKey,
  (state: TcFilterState) => {
    return R.propOr(null, 'config')(state);
  }
);
